import React, { useState } from 'react';
import { ChevronDown } from 'react-feather';

const bgColors: Record<string, string> = {
  green: 'bg-green-100',
  'green-2': 'bg-green-200',
  red: 'bg-red-100',
  'red-2': 'bg-red-200',
  orange: 'bg-orange-100',
  'orange-2': 'bg-orange-200',
  purple: 'bg-purple-100',
  teal: 'bg-teal-100',
  yellow: 'bg-yellow-100',
  blue: 'bg-blue-100',
  gray: 'bg-gray-100',
};

interface ChipDropdownOption {
  label?: string;
}

interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  color?: keyof typeof bgColors;
  avatar?: string;
  number?: number;
  onClickOption?: (option: ChipDropdownOption) => void;
  options?: ChipDropdownOption[];
}

export const Chip = ({
  children,
  color = 'green',
  avatar,
  number,
  options,
  onClickOption,
  className,
  ...props
}: ChipProps) => {
  return (
    <div
      className={`h-[28px] text-[14px]/[21px] font-sofia-pro-soft w-fit text-gray-800 ${bgColors[color]} rounded-full flex`}
    >
      <span className={`p-[2px] w-fit flex justify-center gap-2 `}>
        <span className={`h-[24px] whitespace-nowrap pl-2 ${avatar || number ? '' : 'pr-2'} ${className}`} {...props}>
          {children}
        </span>
        {avatar && (
          <span>
            <img
              src={avatar}
              alt="avatar"
              className="max-w-[24px] min-w-[24px] max-h-[24px] min-h-[24px] rounded-full"
            />
          </span>
        )}
        {number && (
          <span>
            <span
              className="min-w-[24px] max-h-[24px] min-h-[24px] px-2 
                text-gray-800 bg-white
                text-[0.875rem] font-sofia-pro-soft
                rounded-full flex justify-center items-baseline"
            >
              {number}
            </span>
          </span>
        )}
      </span>
      {options && (
        <span className="flex items-center">
          <ChipDropdown options={options} onClickOption={onClickOption} />
        </span>
      )}
    </div>
  );
};

interface ChipDropdownProps {
  options: ChipDropdownOption[];
  onClickOption?: (option: ChipDropdownOption) => void;
}

const ChipDropdown = ({ options, onClickOption }: ChipDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      className="flex flex-col max-w-7 items-end
    hover:bg-opacity-20 bg-opacity-0 bg-black rounded-r-full
    border-l-2 border-black border-opacity-5
    transition-all duration-50"
    >
      <button
        className="pl-1 pr-1.5 text-neutral-500 hover:text-neutral-700 focus:outline-none"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onBlur={() => setIsOpen(false)}
      >
        <span>
          <ChevronDown className="w-4 h-[28px] text-black/80" />
        </span>
      </button>
      {isOpen && (
        <div
          className="absolute mt-8
              bg-white rounded-md  z-10
              flex flex-col items-end
              "
          role="menu"
        >
          {options.map((option) => (
            <button
              key={option.label}
              className="px-2 p-1 w-full hover:bg-gray-100 text-right
                rounded-md
              "
              role="menuitem"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                onClickOption?.(option);
                setIsOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
